import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M4.35671 18.4486C6.61407 17.1727 9.222 16.4444 12 16.4444C14.778 16.4444 17.3859 17.1727 19.6433 18.4486M15.3333 9.77778C15.3333 11.6187 13.8409 13.1111 12 13.1111C10.1591 13.1111 8.66667 11.6187 8.66667 9.77778C8.66667 7.93683 10.1591 6.44444 12 6.44444C13.8409 6.44444 15.3333 7.93683 15.3333 9.77778ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        fill: "none"
      })
    ], -1)
  ])))
}
export default { render: render }